/**
 * Homepage showcase content from the real Dinosaur Days adventure (DD-04).
 * Text and art are copied exactly from the app library; do not edit wording.
 */
export interface ShowcaseCard {
  id: string
  tab: string
  text: string
  src: string
  alt: string
  width: number
  height: number
}

export const showcaseCards: ShowcaseCard[] = [
  {
    id: 'teeth',
    tab: 'Teeth',
    text: 'Flat grinding teeth and slicing teeth point to different ways of breaking food apart.',
    src: 'https://cdn.magicpatterns.com/uploads/ds8YpVpEweDvKqWMDwTdjH/DD-04-05-mechanism-1.png',
    alt: 'Two children compare broad flat dinosaur teeth and pointed dinosaur teeth.',
    width: 1024,
    height: 1024,
  },
  {
    id: 'jaws',
    tab: 'Jaws',
    text: 'Jaw joints and muscle areas show which chewing or biting motions were even possible.',
    src: 'https://cdn.magicpatterns.com/uploads/9HstqJzWF5Y8PPWpZWtEQE/DD-04-06-mechanism-2.png',
    alt: 'A child uses a magnifying glass to study a fossil jaw and arrows showing how it could move.',
    width: 1024,
    height: 1024,
  },
  {
    id: 'clues',
    tab: 'More clues',
    text: 'Tiny scratches, chipped edges, stomach contents and nearby plant fossils add still more.',
    src: 'https://cdn.magicpatterns.com/uploads/iAZ1QJHrUbAn1akr5rFKga/DD-04-07-mechanism-3.png',
    alt: 'A magnifier, fossil leaves, a chipped bone, and other clues show different kinds of evidence.',
    width: 1024,
    height: 1024,
  },
]

export const showcaseQuestion = {
  question: 'How do scientists study what dinosaurs ate?',
  options: [
    'They trust one pointy tooth alone',
    'They guess from the dinosaur’s size',
    'They compare teeth, jaws, wear, and other clues',
    'They use only fossilized footprints',
  ],
  correctIndex: 2,
  explanation: 'Scientists compare several kinds of evidence.',
}
